import React from 'react';

export default function RequiredAstrisk() {
    return <span style={{color:"red"}}>*</span>;
}


// WEBPACK FOOTER //
// ./src/components/common/RequiredAstrisk.js